
export class GlobalEntObj {
    constructor () {
        this.contextPath = null;
        this.pageData = null;
        this.listPageLogic = null;
        this.clickMenu = {
            defaultMenuId: null,
            rowId: null,
            optParam1: null,
            optParam2: null,
            useMatrixItemLink: false,
            hideTimer: 0,
            hideSubTimer: 0,
            activeSubMenu: null,
            clickMenuShowIndex: 0,
            pageId: null,
            currentlyShowingMenu: null, // The menu element which is currently visible
            clickedElem: null, // The menu element which is currently visible
        };
        this.eTree = null;
        this.ajax = {
            lastUserActivityMs: null,
            pollTimer: null
        }
        this.showingSystemMessages = false;
        this.resizeTimeout = null;
        this.isScrolling = false;
        this.origFormSubject = null;

        this.datePicker = null;
        this.vdxEventBus = null;
        this.progbar = null;

        this.classes = {};
        this.functions = {};
    }
}